module.exports = __webpack_public_path__ + "img/KV1.805ab493.jpg";